import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "../../components/Config/AxiosIni";
import { AxiosError } from 'axios';

// Definimos los tipos para los campos del formulario
interface FormState {
  username?: string;
  password?: string;
}

// Hook principal
export const useLogin = () => {
    const navigate = useNavigate();

    const [formState, setFormState] = useState<FormState>({});
    const [loaderState, setLoaderState] = useState<boolean>(false);
    const [emptyText, setEmptyText] = useState<boolean>(false);
    const [emptyUser, setEmptyUser] = useState<boolean>(false);

    const onChangeInput = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const field = event.target.name as keyof FormState;
        const value = event.target.value;

        setFormState({
        ...formState,
        [field]: value,
        });
    };

    const handleSubmitLogin = (
        event: React.FormEvent<HTMLFormElement>
    ) => {
        event.preventDefault();
        setEmptyText(false);
        setEmptyUser(false);

        if (!formState.username || formState.username.trim() === "") {
        setEmptyUser(true);
        Swal.fire(
            "Login de Usuario",
            "Ingresar Datos solicitados para continuar",
            "error"
        );
        } else if (!formState.password || formState.password.trim() === "") {
        setEmptyText(true);
        Swal.fire(
            "Login de Usuario",
            "Ingresar Datos solicitados para continuar",
            "error"
        );
        } else {
        setEmptyText(false);
        setEmptyUser(false);
        setLoaderState(true);
        userLogin();
        }
    };

    const userLogin = async () => {
        try {
            const { data } = await axios.post("/auth/login", formState);
            console.log("ariel-ligon", data.token);
            localStorage.setItem("user", data.token);
            navigate("/administrar");
        } catch (error: any) {
            console.log("ariel-error", error);            
            if (error.message === "Network Error") {
                Swal.fire(
                "Error Leer Atte.",
                "No se pudo conectar con el servidor. Verifica tu conexión a internet o intenta más tarde.",
                "error"
                );
            } else {
                Swal.fire(
                "Error Leer Atte.",
                error.response?.data?.message || "Error inesperado",
                "error"
                );
            }
        } finally {
            setLoaderState(false);
        }
    };

    const handleRegister = () => {
        navigate("/registrar");
    };

    //* Procecimiento para realizar el auto logueo
    const autoLogin = async (token: string): Promise<void> => {    
    console.log('ariel-token', token);    
    try {
        const response = await axios.get('/auth/token', {
        headers: { Authorization: token },
        });    
        navigate("/administrar");
    } catch (error: unknown) {
        console.log('ariel-error', error);    
        const axiosError = error as AxiosError<any>;
        const tipoError = axiosError.response?.data?.tipoerror;

        switch (tipoError) {
        case 'tokenexp':
            /* Swal.fire({
            title: 'Error Leer Atte.',
            text: axiosError.response?.data?.message,
            icon: 'error',
            confirmButtonColor: '#e31474',
            confirmButtonText: 'Ok',
            }).then((result) => {
            if (result.isConfirmed) {
                navigate('/login');
            }
            }); */
            localStorage.clear();
            break;

            case 'NoRegistra':
                Swal.fire({
                title: 'Error Leer Atte.',
                text: axiosError.response?.data?.message,
                icon: 'error',
                confirmButtonColor: '#e31474',
                confirmButtonText: 'Ok',
                }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/login');
                }
                });
                break;
    
        case 'Network Error':
            Swal.fire(
            'Error Leer Atte.',
            'No se pudo conectar con el servidor. Verifica tu conexión a internet o intenta más tarde.',
            'error'
            );
            break;
    
        default:
            Swal.fire('Error Leer Atte.', axiosError.message, 'error');
            break;
        }
    }
    };

    useEffect(() => {
    const token = localStorage.getItem('user');
    if(token){
        autoLogin(token);
    }
    }, []);

    return {
        formState,
        loaderState,
        emptyText,
        emptyUser,
        setLoaderState,
        handleSubmitLogin,
        handleRegister,
        onChangeInput,
        setFormState,
    };
};